export enum StatementsDataEnum {
  yoyChange = 'yoyChange',
  yoyChangePct = 'yoyChangePct',
}

export enum StatementsTimeframeEnum {
  annual = 'annual',
  quarterly = 'quarterly',
}

export const SETTINGS_COOKIE_KEY = 'quoteStatementsTableSettings'

export const DEFAULT_SETTINGS = {
  [StatementsDataEnum.yoyChange]: false,
  [StatementsDataEnum.yoyChangePct]: false,
  statementsTimeframe: StatementsTimeframeEnum.annual,
}

export type StatementsType = {
  [StatementsDataEnum.yoyChange]: boolean
  [StatementsDataEnum.yoyChangePct]: boolean
  statementsTimeframe: StatementsTimeframeEnum
}
